import { HomeHeader } from '../home/HomeHeader'
import { useAuth } from '../../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import SettingsPanel from '../dashboard/SettingsPanel'
import { ArrowLeft } from 'lucide-react'
import { Button } from '../ui/button'

export function Upload() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    try {
      await logout()
      navigate('/')
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  return (
    <div className="min-h-screen bg-background">
      <HomeHeader user={user} onLogout={handleLogout} />
      
      <div className="container mx-auto px-4 py-6">
        {/* Compact Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-2 h-8 bg-primary rounded-full"></div>
            <div>
              <h1 className="text-2xl font-bold text-foreground">Upload Book</h1>
              <p className="text-sm text-muted-foreground">
                Upload and configure your book for translation and simplification
              </p>
            </div>
          </div>
          
          <Button 
            variant="outline"
            onClick={() => navigate('/my-books')}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Books
          </Button>
        </div>

        {/* Upload Content */}
        <div className="max-w-4xl">
          <SettingsPanel />
        </div>
      </div>
    </div>
  )
}
